<template>
  <div class="content if-profile customize_report report-tab">
    <div class="md-layout profit-loss">
      <IFReportHeader :headerData="this.headerData" />

      <div class="content-checkbox mt-4">
        <div
          class="md-layout-item md-medium-size-100 md-size-100 md-large-size-100 p-0 mt-4"
        >
          <h1 class="section_header">Customize Report</h1>
          <div>
            <md-tabs md-alignment="left">
              <md-tab
                id="content-years"
                md-label="Check to display content years"
                md-icon="arrow_drop_down"
                class="p-0"
              >
                <div class="md-layout">
                  <div class="md-layout-item p-0">
                    <md-card-header
                      >Check to display content years</md-card-header
                    >
                    <md-card-content>
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-50 p-0"
                        >
                          <div class="full-control">
                            <!-- <md-list> -->
                            <div class="md-layout">
                              <div class="md-layout-item md-size-100 p-0">
                                <div
                                  :key="key"
                                  v-for="(value, key) in years.slice(0, 3)"
                                  class="checkbox-customize md-size-100"
                                >
                                  <md-list-item class="md-size-40">
                                    <md-checkbox
                                      v-model="checked"
                                      :value="`year_${key}`"
                                    />
                                    <span class="md-list-item-text">{{
                                      value
                                    }}</span>
                                  </md-list-item>
                                </div>
                              </div>
                            </div>
                            <!-- </md-list> -->
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-50 p-0"
                        >
                          <div class="full-control">
                            <!-- <md-list> -->
                            <div class="md-layout">
                              <div class="md-layout-item md-size-100 p-0">
                                <div
                                  :key="getSecondColumnKey(key)"
                                  v-for="(value, key) in years.slice(
                                    3,
                                    years.length
                                  )"
                                  class="checkbox-customize md-size-100"
                                >
                                  <md-list-item class="md-size-40">
                                    <md-checkbox
                                      v-model="checked"
                                      :value="`year_${getSecondColumnKey(key)}`"
                                    />
                                    <span class="md-list-item-text">{{
                                      value
                                    }}</span>
                                  </md-list-item>
                                </div>
                              </div>
                            </div>
                            <!-- </md-list> -->
                          </div>
                        </div>
                      </div>
                    </md-card-content>
                  </div>
                </div>
                <div
                  v-if="!isSample"
                  @click="saveReport()"
                  class="md-layout-item md-size-100 submit-box p-0"
                >
                  <md-button
                    :md-ripple="false"
                    class="md-info md-block access-button bottom-check"
                    >Submit</md-button
                  >
                </div>
              </md-tab>
              <md-tab
                id="metrics"
                md-label="Check to display metrics"
                md-icon="arrow_drop_down"
                class="p-0"
              >
                <div class="md-layout">
                  <div class="md-layout-item p-0">
                    <md-card-header>Check to display metrics</md-card-header>
                    <md-card-content>
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-50 p-0"
                        >
                          <div class="full-control">
                            <!-- <md-list> -->
                            <!-- <md-subheader class="customize-report-year">Check To display Content Metrics</md-subheader> -->
                            <div class="md-layout">
                              <div class="md-layout-item md-size-100 p-0">
                                <div class="checkbox-customize md-size-100">
                                  <md-list-item class="md-size-40">
                                    <md-checkbox
                                      v-model="checked"
                                      value="pl_balance_percent"
                                    />
                                    <span class="md-list-item-text">
                                      Show P&amp;L and Balance Sheet percentages
                                    </span>
                                  </md-list-item>
                                </div>
                                <div class="checkbox-customize md-size-100">
                                  <md-list-item class="md-size-40">
                                    <md-checkbox
                                      v-model="checked"
                                      value="ratio_scores"
                                    />
                                    <span class="md-list-item-text"
                                      >Display Ratio Scores</span
                                    >
                                  </md-list-item>
                                </div>
                                <div class="checkbox-customize md-size-100">
                                  <md-list-item class="md-size-40">
                                    <md-checkbox
                                      v-model="checked"
                                      value="summary_scores"
                                    />
                                    <span class="md-list-item-text"
                                      >Display Summary Scores Page</span
                                    >
                                  </md-list-item>
                                </div>
                              </div>
                            </div>
                            <!-- </md-list> -->
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-50 p-0"
                        >
                          <div class="full-control">
                            <!-- <md-list> -->
                            <div class="md-layout">
                              <div class="md-layout-item md-size-100 p-0">
                                <div class="checkbox-customize md-size-100">
                                  <md-list-item class="md-size-40">
                                    <md-checkbox
                                      v-model="checked"
                                      value="pl_balance_dollar"
                                    />
                                    <span class="md-list-item-text"
                                      >Show P&L and Balance Sheet dollars</span
                                    >
                                  </md-list-item>
                                </div>
                                <div class="checkbox-customize md-size-100">
                                  <md-list-item class="md-size-40">
                                    <md-checkbox
                                      v-model="checked"
                                      value="source_uses"
                                    />
                                    <span class="md-list-item-text"
                                      >Sources-Uses Table</span
                                    >
                                  </md-list-item>
                                </div>
                              </div>
                            </div>
                            <!-- </md-list> -->
                          </div>
                        </div>
                      </div>
                    </md-card-content>
                  </div>
                </div>
                <div
                  v-if="!isSample"
                  @click="saveReport()"
                  class="md-layout-item md-size-100 submit-box p-0"
                >
                  <md-button
                    :md-ripple="false"
                    class="md-info md-block access-button bottom-check"
                    >Submit</md-button
                  >
                </div>
              </md-tab>
              <md-tab
                id="ratios"
                md-label="Check ratios for display"
                md-icon="arrow_drop_down"
                class="p-0"
              >
                <div class="md-layout">
                  <div class="md-layout-item p-0">
                    <md-card-header>Check ratios for display</md-card-header>
                    <md-card-content>
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-50 p-0"
                        >
                          <div
                            v-for="(ratio, index) in leftRatioOutput"
                            :key="index + 'left'"
                          >
                            <div
                              v-if="ratio.checkbox"
                              class="checkbox-customize md-size-100"
                            >
                              <md-list-item class="md-size-40">
                                <md-checkbox
                                  v-model="checked"
                                  :value="ratio.id"
                                />
                                <span class="md-list-item-text">
                                  {{ ratio.title }}
                                </span>
                              </md-list-item>
                            </div>
                            <div
                              v-else-if="ratio.title"
                              class="md-size-100 sub_title"
                            >
                              {{ ratio.title }}
                            </div>
                            <div v-else class="checkbox-customize md-size-100">
                              <md-list-item class="md-size-40"></md-list-item>
                            </div>
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-50 p-0"
                        >
                          <div
                            v-for="(ratio, index) in rightRatioOutput"
                            :key="index + 'right'"
                          >
                            <div
                              v-if="ratio.checkbox"
                              class="checkbox-customize md-size-100"
                            >
                              <md-list-item class="md-size-40">
                                <md-checkbox
                                  v-model="checked"
                                  :value="ratio.id"
                                />
                                <span class="md-list-item-text">
                                  {{ ratio.title }}
                                </span>
                              </md-list-item>
                            </div>

                            <div
                              v-else-if="ratio.title"
                              class="md-size-100 sub_title"
                            >
                              {{ ratio.title }}
                            </div>

                            <div v-else class="checkbox-customize md-size-100">
                              <md-list-item class="md-size-40"></md-list-item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </md-card-content>
                  </div>
                </div>
                <div
                  @click="saveReport()"
                  class="md-layout-item md-size-100 submit-box p-0"
                >
                  <md-button
                    :md-ripple="false"
                    class="md-info md-block access-button bottom-check"
                    >Submit</md-button
                  >
                </div>
              </md-tab>
              <md-tab
                id="Developer-Client"
                md-label="Client Display (optional)"
                md-icon="arrow_drop_down"
                class="p-0"
              >
                <div class="md-layout">
                  <div class="md-layout-item p-0">
                    <md-card-header>Client Display (optional)</md-card-header>
                    <md-card-content>
                      <div class="md-layout contact-form">
                        <div class="md-layout-item md-size-100 p-0">
                          <div class="md-layout d-flex">
                            <div class="md-layout-item">
                              <label>Client Name:</label>
                            </div>
                            <div class="md-layout-item">
                              <md-field class="input m-0">
                                <md-input
                                  v-model="client_name"
                                  class="form-imput"
                                  placeholder="Input the client name"
                                ></md-input>
                              </md-field>
                            </div>
                          </div>
                          <div v-if="false" class="md-layout customize-form">
                            <div class="md-layout-item choose-img-box">
                              <div class="label_wpr">
                                <label>Client Logo:</label>
                                <md-field class="label m-0">
                                  <div class="remove-img-box">
                                    <img :src="base" alt="Avatar" />
                                    <a
                                      @click="
                                        saveReport('remove', 'clientLogo')
                                      "
                                      class="close_btn"
                                    >
                                      <i class="md-icon">close</i>
                                    </a>
                                  </div>
                                </md-field>
                              </div>
                            </div>
                            <div class="md-layout-item">
                              <div class="choose-files-box">
                                <md-field class="choose-file icon-choose-box">
                                  <label v-if="!client_logo">Choose File</label>
                                  <md-file
                                    v-model="client_logo"
                                    accept="image/*"
                                  />
                                </md-field>
                                <p v-if="!client_logo">No Choose file</p>
                              </div>
                              <p>
                                (maximum dimensions of 800px x 800px ): PNG,
                                JPG, JEPG, GIF
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </md-card-content>
                  </div>
                </div>
                <div
                  v-if="!isSample"
                  @click="saveReport()"
                  class="md-layout-item md-size-100 submit-box p-0"
                >
                  <md-button
                    :md-ripple="false"
                    class="md-info md-block access-button bottom-check"
                    >Submit</md-button
                  >
                </div>
              </md-tab>
            </md-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import IFReportHeader from "./_partials/IFHeader.vue";

export default {
  components: {
    IFReportHeader,
  },
  props: ["headerData"],
  data() {
    return {
      ringtone: "peace",
      base: process.env.VUE_APP_API_BASE_URL + "/IFBB_Images/",
      clientFile: null,
      clientLogo: null,
      loading: false,
      developer_name: null,
      developer_phone: null,
      developer_email: null,
      developer_logo: null,
      client_name: null,
      client_logo: null,
      checked: [],
      allChecked: [
        "accounts_payable_business_revenue",
        "ebitda_business_revenue",
        "current_ratio",
        "return_on_assets",
        "quick_ratio",
        "return_on_net_worth",
        "days_payable",
        "return_on_business_revenue",
        "current_liabilities_inventory",
        "discretionary_owner_earnings",
        "net_working_capital",
        "return_on_assets_after_tax",
        "cosPayables",
        "return_on_net_worth_after_tax",
        "cosInventory",
        "return_on_business_revenue_after_tax",
        "assets_business_revenue",
        "interest_coverage",
        "days_inventory",
        "current_liabilities_net_worth",
        "days_receivables",
        "long_term_liabilities_net_worth",
        "current_asset_turnover",
        "loans_notes_payable_net_worth",
        "fixed_asset_turnover",
        "zscore",
        "gross_margin_business_revenue",
        "total_liabilities_net_worth",
        "sales_per_employee",
        "fixedAssetsNetWorth",
        "invTurnover",
        "arTurnover",
        "totalAssetTurnover",
        "workingCapitalTurnover",
        "daysWorkingCapital",
        "cashTurnover",
        "efficiency_index",
        "profit_employee",
        "owner_earnings_employee",
      ],
      placeholder: null,
    };
  },
  computed: {
    ...mapState({
      displaySettings: (state) => state.user.report.displaySettings,
      developerClient: (state) => state.user.report.developerClient,
      data_descriptions: (state) => state.user.report.data_descriptions,
      ratioOutput: (state) => state.user.report.ratioOutput,
      years: (state) => state.user.report.years,
    }),
    leftRatioOutput() {
      return this.ratioOutput.map((ratio) => ratio.left);
    },
    rightRatioOutput() {
      return this.ratioOutput.map((ratio) => ratio.right);
    },
    isSample() {
      return this.$route.path.indexOf("sample") > -1;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions({
      save: "user/saveReport",
      getReport: "user/getReport",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      updatePullTime: "tracking/updatePullTime",
    }),
    init() {
      this.checked = [...this.displaySettings].filter((i) => i);
      // this.checked = [...this.checked, ...this.displaySettings].filter(i => i);
      this.developer_name = this.developerClient.developer_name;
      this.developer_phone = this.developerClient.developer_phone;
      this.developer_email = this.developerClient.developer_email;
      this.developer_logo = this.developerClient.developer_logo;
      this.client_name = this.developerClient.client_name;
      this.client_logo = this.developerClient.client_logo;
    },
    getSecondColumnKey(key) {
      return parseInt(key) + 3;
    },

    checkUncheck(isChecked) {
      this.ratioOutput.forEach(({ left, right }) => {
        if (left.id || right.id) {
          if (isChecked) {
            if (left.id) this.checked.push(left.id);
            if (right.id) this.checked.push(right.id);
          } else {
            if (this.checked.includes(left.id))
              this.checked = this.checked.filter((i) => i !== left.id);
            if (this.checked.includes(right.id))
              this.checked = this.checked.filter((i) => i !== right.id);
          }
        }
      });
    },
    onFileUpload(event) {
      this.developer_logo = event;
    },
    saveReport(action = "save", logo) {
      // action: clear/remove/save
      this.loading = true;
      let params = {};

      if (action === "save") {
        // params.data = [...this.checked];
        params.data = this.checked
          .filter((i) => i)
          .reduce(
            (acc, cur) => ({
              ...acc,
              [cur + "_check"]: true,
            }),
            {}
          );
        params.developer_name = this.developer_name || null;
        params.developer_phone = this.developer_phone || null;
        params.developer_email = this.developer_email || null;
        // params.developer_logo = this.developer_logo || null;
        params.client_name = this.client_name || null;
        params.client_logo = this.client_logo || null;
      }

      if (action === "remove") {
        params.data = logo;
      }

      params = _.omitBy(params, _.isEmpty);

      this.save({
        report_id: this.$route.params.id,
        profile_id: this.$route.params.id,
        type: "if",
        action: action,
        ...params,
      })
        .then((res) => {
          this.alertSuccess("Data loaded.");

          this.$router.push({
            name: "IFAboutTheData",
            params: this.$route.params.id,
          });
          this.$router.go();
        })
        .catch((err) => {
          this.alertSuccess("Data loaded.");
        })
        .finally(() => {
          this.loading = false;
          this.updatePullTime({
            isFinishedDate: true,
            productId: this.$route.params.id,
          });
        });
    },
    onCompanyChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.createCompanyImage(files[0]);
    },
    createCompanyImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.clientLogo = e.target.result;
        this.clientFile = file;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
<style lang="scss" scoped>
.content-checkbox {
  .contact-box {
    padding: 20px 0 0 20px !important;
  }

  .customize-report-year {
    color: #3b7ef1;

    .full-control {
      .md-list {
        max-width: 100%;
        height: 400px;
        display: inline-block;
        overflow: auto;
        border: 1px solid rgba(#000, 0.12);
        vertical-align: top;
      }
    }
  }

  .md-ripple {
    width: 200px !important;

    span {
      position: inherit !important;
      font-size: 0.9625rem;
      color: #3c4858;
      font-weight: 300;
    }

    .title-box {
      align-items: center !important;
      color: #3b7ef1;
    }
  }

  .check-all {
    border-top: 1px solid !important;
    border-top-color: #ddd !important;
  }

  .checkbox-customize {
    display: flex !important;
    justify-content: space-between !important;
    border-bottom: 1px solid !important;
    border-bottom-color: #ddd !important;

    .bottom-check {
      cursor: pointer;
      background-color: #3b7ef1;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      width: auto !important;
      margin-left: 10px;
    }
  }

  .md-list-item-container {
    width: 350px !important;
  }

  .title-text {
    color: #3b7ef1;
  }

  .choose-files-box {
    display: flex;
    align-items: center;

    p {
      margin: 0 0 0 10px;
    }

    .choose-file::v-deep {
      background-color: #e3e4e5;
      width: 120px;
      border-radius: 3px;
      padding: 0;
      margin: 0;
      align-items: center;

      label {
        margin-right: 11px;
        position: absolute;
        left: 24px;
        top: 9px;
      }

      i {
        display: none;
      }
    }
  }

  .choose-img-box {
    display: flex;
    align-items: center;

    img {
      width: 80px;
      height: 55px;
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }
}

.icon-choos-box {
  .md-icon {
    display: none !important;
  }
}

h4.main-street {
  padding-top: 0;
}

.financal-report-col-3 {
  display: flex;
  justify-content: flex-end;
}

.submit-box {
  display: flex;
  justify-content: flex-end;

  button {
    background-color: #3b7ef1 !important;
  }
}

.remove-img-box {
  display: flex;
  align-items: center;
}
</style>
